/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Resource } from '../models/resource';
import { resourceControllerCountDataResourcesFromGenerator } from '../fn/resources/resource-controller-count-data-resources-from-generator';
import { ResourceControllerCountDataResourcesFromGenerator$Params } from '../fn/resources/resource-controller-count-data-resources-from-generator';
import { resourceControllerCountStudentsInPhase } from '../fn/resources/resource-controller-count-students-in-phase';
import { ResourceControllerCountStudentsInPhase$Params } from '../fn/resources/resource-controller-count-students-in-phase';
import { resourceControllerCreateResource } from '../fn/resources/resource-controller-create-resource';
import { ResourceControllerCreateResource$Params } from '../fn/resources/resource-controller-create-resource';
import { resourceControllerDeleteResource } from '../fn/resources/resource-controller-delete-resource';
import { ResourceControllerDeleteResource$Params } from '../fn/resources/resource-controller-delete-resource';
import { resourceControllerQueryResources } from '../fn/resources/resource-controller-query-resources';
import { ResourceControllerQueryResources$Params } from '../fn/resources/resource-controller-query-resources';
import { resourceControllerReadResource } from '../fn/resources/resource-controller-read-resource';
import { ResourceControllerReadResource$Params } from '../fn/resources/resource-controller-read-resource';
import { resourceControllerResourceExists } from '../fn/resources/resource-controller-resource-exists';
import { ResourceControllerResourceExists$Params } from '../fn/resources/resource-controller-resource-exists';
import { resourceControllerUpdateResource } from '../fn/resources/resource-controller-update-resource';
import { ResourceControllerUpdateResource$Params } from '../fn/resources/resource-controller-update-resource';

@Injectable({ providedIn: 'root' })
export class ResourcesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `resourceControllerCreateResource()` */
  static readonly ResourceControllerCreateResourcePath = '/resources/{alwaysAllowActor}';

  /**
   * Create a resource.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceControllerCreateResource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceControllerCreateResource$Response(params: ResourceControllerCreateResource$Params, context?: HttpContext): Observable<StrictHttpResponse<Resource>> {
    const obs = resourceControllerCreateResource(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a resource.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resourceControllerCreateResource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceControllerCreateResource(params: ResourceControllerCreateResource$Params, context?: HttpContext): Observable<Resource> {
    const resp = this.resourceControllerCreateResource$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Resource>): Resource => r.body)
    );
  }

  /** Path part for operation `resourceControllerReadResource()` */
  static readonly ResourceControllerReadResourcePath = '/resources/{resourceId}';

  /**
   * Read a resource.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceControllerReadResource()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceControllerReadResource$Response(params: ResourceControllerReadResource$Params, context?: HttpContext): Observable<StrictHttpResponse<Resource>> {
    const obs = resourceControllerReadResource(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Read a resource.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resourceControllerReadResource$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceControllerReadResource(params: ResourceControllerReadResource$Params, context?: HttpContext): Observable<Resource> {
    const resp = this.resourceControllerReadResource$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Resource>): Resource => r.body)
    );
  }

  /** Path part for operation `resourceControllerUpdateResource()` */
  static readonly ResourceControllerUpdateResourcePath = '/resources/{resourceId}';

  /**
   * Update a resource.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceControllerUpdateResource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceControllerUpdateResource$Response(params: ResourceControllerUpdateResource$Params, context?: HttpContext): Observable<StrictHttpResponse<Resource>> {
    const obs = resourceControllerUpdateResource(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a resource.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resourceControllerUpdateResource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceControllerUpdateResource(params: ResourceControllerUpdateResource$Params, context?: HttpContext): Observable<Resource> {
    const resp = this.resourceControllerUpdateResource$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Resource>): Resource => r.body)
    );
  }

  /** Path part for operation `resourceControllerDeleteResource()` */
  static readonly ResourceControllerDeleteResourcePath = '/resources/{resourceId}';

  /**
   * Delete a resource.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceControllerDeleteResource()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceControllerDeleteResource$Response(params: ResourceControllerDeleteResource$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = resourceControllerDeleteResource(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a resource.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resourceControllerDeleteResource$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceControllerDeleteResource(params: ResourceControllerDeleteResource$Params, context?: HttpContext): Observable<void> {
    const resp = this.resourceControllerDeleteResource$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `resourceControllerResourceExists()` */
  static readonly ResourceControllerResourceExistsPath = '/resources/{ilsId}/{resourceId}/exists';

  /**
   * Does a resource exist.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceControllerResourceExists()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceControllerResourceExists$Response(params: ResourceControllerResourceExists$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = resourceControllerResourceExists(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Does a resource exist.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resourceControllerResourceExists$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceControllerResourceExists(params: ResourceControllerResourceExists$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.resourceControllerResourceExists$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `resourceControllerQueryResources()` */
  static readonly ResourceControllerQueryResourcesPath = '/resources';

  /**
   * Query for resources.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceControllerQueryResources()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceControllerQueryResources$Response(params: ResourceControllerQueryResources$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Resource>>> {
    const obs = resourceControllerQueryResources(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Query for resources.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resourceControllerQueryResources$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceControllerQueryResources(params: ResourceControllerQueryResources$Params, context?: HttpContext): Observable<Array<Resource>> {
    const resp = this.resourceControllerQueryResources$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Resource>>): Array<Resource> => r.body)
    );
  }

  /** Path part for operation `resourceControllerCountDataResourcesFromGenerator()` */
  static readonly ResourceControllerCountDataResourcesFromGeneratorPath = '/resources/countGenerator/{ilsId}/{generatorId}';

  /**
   * Count app resources.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceControllerCountDataResourcesFromGenerator()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceControllerCountDataResourcesFromGenerator$Response(params: ResourceControllerCountDataResourcesFromGenerator$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    const obs = resourceControllerCountDataResourcesFromGenerator(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Count app resources.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resourceControllerCountDataResourcesFromGenerator$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceControllerCountDataResourcesFromGenerator(params: ResourceControllerCountDataResourcesFromGenerator$Params, context?: HttpContext): Observable<number> {
    const resp = this.resourceControllerCountDataResourcesFromGenerator$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `resourceControllerCountStudentsInPhase()` */
  static readonly ResourceControllerCountStudentsInPhasePath = '/resources/countStudents/{ilsId}/{phaseId}';

  /**
   * Count the number of students using the phase.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceControllerCountStudentsInPhase()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceControllerCountStudentsInPhase$Response(params: ResourceControllerCountStudentsInPhase$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    const obs = resourceControllerCountStudentsInPhase(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Count the number of students using the phase.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resourceControllerCountStudentsInPhase$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceControllerCountStudentsInPhase(params: ResourceControllerCountStudentsInPhase$Params, context?: HttpContext): Observable<number> {
    const resp = this.resourceControllerCountStudentsInPhase$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

}
